<template>
	<div class="wrap">
		<div class="page_title"><b>租户管理</b></div>
		<div class="main public_box">
			<tenant-package-admin-hl></tenant-package-admin-hl>
		</div>
	</div>
</template>

<script> 
// @ is an alias to /src
import TenantPackageAdminHl from "@/package/tenantPackageAdminHl/index.vue";
export default {
	name: 'tenantPackageAdmin',
	components: {
    TenantPackageAdminHl
	},
	data(){
		return{
			loading:false,
			menuType:'searchReviewPage'
		}
	},
	methods:{
		
	},
	mounted() {  // 

	}
}
</script>
<style scoped>
	.main{
		margin-top: 0.2rem;
	}
</style>
